import React, { useState, useEffect, useRef, useCallback } from 'react';
import Grid from '@material-ui/core/Grid';
import ImputComponent from "./../../InputComponent"
import { LanguageFactory, LocalPersistence } from '../../../factories';
import { useLanguage } from '../../../store/languageContext'
import SearchDebounceBar from './../../SearchDebounce';
import SearchIcon from '@material-ui/icons/Search';
import { PropertySearch } from '../../../factories/propertySearchs';
import { Button, Table, Card } from 'antd';
import { getAttractions } from '../../../services/attraction'
import Loading from '../../Loading';
import styles from './../index.module.css'
import PageContainer from '../../CSIComponents/PageContainer';
import { sortHelper } from '../../../helpers/misc/sortHelper'
import { paginationSize, getPaginationSession } from '@helpers/misc/setPaginationSize'

const AttractionsTable = (props:{currentFlag:any,setCurrentFlag?:any,setCurrentLine?:any,isEditable:any,cancelEditable:any}) => {
    const { language } = useLanguage()
    const lang = new LanguageFactory(language)
    const initialRender = useRef(true);
    const [searchs, setSearch] = useState<string[]>([])
    const [dataSource, setDataSource] = useState<object[]>([])
    const [tableLoading, setTableLoading] = useState(false)
    const [paginationData, setPaginationData] = useState<number>(10)
    const columns = [
        {
            title: '',
            key: 'index',
            // @ts-ignore ignoring as there are data issues
            render: (text, record, index) => Number(record?.key) ? Number(record?.key) + 1 : index += 1,
            width: '40px'
        },
        {
            title: lang.translate(language, 'attraction_column1'),
            dataIndex: 'name',
            key: 'name',
            // @ts-expect-error ignoring as there are data issues
            sorter: (a, b) => sortHelper(a, b, 'name'),
            showSorterTooltip: false
        },
        {
            title: lang.translate(language, 'attraction_column2'),
            dataIndex: 'type',
            key: 'type',
            // @ts-expect-error ignoring as there are data issues
            sorter: (a, b) => sortHelper(a, b, 'type'),
            showSorterTooltip: false
        },
        {
            title: lang.translate(language, 'attraction_column3'),
            dataIndex: 'id',
            key: 'id',
            // @ts-expect-error ignoring as there are data issues
            sorter: (a, b) => sortHelper(a, b, 'id'),
            showSorterTooltip: false
        },
        {
            title: lang.translate(language, 'attraction_column4'),
            dataIndex: 'typestandard',
            key: 'typestandard',
            // @ts-expect-error ignoring as there are data issues
            sorter: (a, b) => sortHelper(a, b, 'typestandard'),
            showSorterTooltip: false
        },
        {
            title: lang.translate(language, 'attraction_column5'),
            dataIndex: 'typedetail',
            key: 'typedetail',
            // @ts-expect-error ignoring as there are data issues
            sorter: (a, b) => sortHelper(a, b, 'typedetail'),
            showSorterTooltip: false
        }
    ]

    const [total, setTotal] = useState(dataSource.length)
    const [data, setData] = useState(dataSource)

    const onChangeSearch = (term: string) => {
        setSearchTerm(term)
        onDebounce(term)
    }
    const {
        searchTerm, setSearchTerm, searchTermDebounced, onDebounce
    } = SearchDebounceBar()
    const recentlySearchs = () => {
        return searchs.map((search, index) => {
            return (
                <span key={index} onClick={() => recoverSearch(search)}>
                    &nbsp;{search}{searchs.length - 1 === index ? '.' : ','}
                </span>
            )
        })
    }

    const recoverSearch = (search: string) => {
        setSearchTerm(search)
        filterData(search)
        onDebounce(search)
    }

    const saveNewSearch = (term: string) => {
        const stackSearchs = new PropertySearch(searchs)
        setSearch(stackSearchs.add(term))
    }

    const afterDebounce = (term: string) => {
        if (term) {
            saveNewSearch(term)
        }
        filterData(term)
    }

    const filterData = async (query: string) => {
        const filterData = data.filter((item: any) => {
            let newFilterData:any = {}
            columns.forEach((col:any) => {
                newFilterData[col['dataIndex']] = (item[col.dataIndex] == null || item[col.dataIndex] == undefined) ? '' : JSON.stringify(item[col.dataIndex]).toLowerCase()
            })
            return JSON.stringify(Object.values(newFilterData)).indexOf(query.toLowerCase()) > -1;

        })
        setDataSource(filterData)
        setData(filterData)
    }
    // search functionality
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            afterDebounce(searchTermDebounced);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [searchTermDebounced])

    const getPaginationData = useCallback(async () => {
        return await getPaginationSession(
            setPaginationData,
            'attractions'
        );
    }, [])
    

    useEffect(() => {
        (async () => {
            setTableLoading(true)
            const get_session = new LocalPersistence('session')
            const session: any = await get_session.getSessionPersistence()
            const responent = await getAttractions(session.supplier, session.propertyId);
            await getPaginationData()
            setTableLoading(false)
            const data:any = responent && responent.property && responent.property.attractions && responent.property.attractions.length != 0 ? responent.property.attractions : []
            data.forEach((item:any, index:any) => { item.key = '' + index; })
            await setDataSource(data)
            setData(data)
            setTotal(dataSource.length)
        }
        )()
        props.currentFlag === 'edit' || props.currentFlag === 'add' ? props.isEditable(true) : props.cancelEditable(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.currentFlag])

return (
    <PageContainer>
        { !tableLoading && 
        <Card style={{marginTop: '-16px'}}>
            
            <Grid container spacing={0} className="containerSpacing py-0">
                <Grid item xs={12} className="p-0">
                    <div className={styles.tableHead}>
                        <div className={styles.tableName}>Attractions</div>
                        <div><Button type='primary' className="db-add-btn" onClick={()=> props.setCurrentFlag('add')}>Add</Button></div>
                    </div>
                </Grid>
                <Grid item xs={4} className="pb-0 px-0 my-0">
                    <ImputComponent
                        className = 'SearchBar'
                        //label={lang.translate(language, 'attraction_search')}
                        label={'Search'}
                        labelShrink = {true}
                        value={searchTerm}
                        onChange={onChangeSearch}
                        placeholder={lang.translate(language, 'attraction_search')}
                        endAdornment={<SearchIcon style={{color: '#9a9a9a'}}/>}
                    />
                    <div className="recentlySearchs">
                        <p>{lang.translate(language, 'recently_searched')}: {recentlySearchs()}</p>
                    </div>
                </Grid>
                <Grid item xs={12} className="p-0">
                    <Table
                        columns={columns} 
                        dataSource={dataSource}
                        onRow={record => {
                        return {
                            onClick: event => {
                                props.setCurrentLine(record)
                                props.setCurrentFlag('view')
                            },
                        };
                        }}
                        pagination={{
                            size: "small",
                            total,
                            showSizeChanger: true,
                            showTotal: (total, range) => `Total ${total} items, Current ${range[0]}-${range[1]}`,
                            pageSizeOptions: ['10', '20','50','100'],
                            defaultPageSize: paginationData,
                            defaultCurrent: 1,
                            onShowSizeChange: (current, size: number) => paginationSize('pagination', { 'attractions': size })
                        }}
                    />
                </Grid>
            </Grid>
        </Card> }
        { tableLoading && <Loading type={'large'} /> }
    </PageContainer>
    
)
}

export default AttractionsTable;
